import React from 'react'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import BankStatementsCollectSF from './BankStatementsCollectSF'
import ITRCollectSF from './ITRCollectSF'
import GSTCollectSF from './GSTCollectSF'

const DocumentsCollectUI = ({context, errorList, account}) =>
  <div>
    {
      !account && !errorList &&
      <SpinnerComponentUI/>
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]}/>
    }
    {
      account &&
      <div>
        We need to authenticate your business information
        <GSTCollectSF context={context} account={account} />
        <ITRCollectSF context={context} account={account} />
        <BankStatementsCollectSF context={context} account={account} />
      </div>
    }
  </div>

export default DocumentsCollectUI
